import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  position: relative;
  width: 100%;
  margin: ${({ lowerMargin }) => lowerMargin ? `80px 0 0 0` : `212px 0 0 0`};
  padding: 0 40px;
  box-sizing: border-box;

  ${media.medium`
    margin: ${({ lowerMargin }) => lowerMargin ? `100px 0 0 0` : `250px 0 0 0`};
    padding: 0 7% 0 14%;
    display: flex;
    flex-direction: row;
  `}
`;
